const COACH_IMAGE =
  "https://images.pexels.com/photos/8465502/pexels-photo-8465502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

// Coach profiles: real details as confirmed by the owner.
const COACH_SLOTS = [
  {
    slot: "Coach 01",
    role: "Founder & Head Coach",
    photo: "/images/coach-gaurav.jpeg",
    name: "Gaurav Gautam",
    rating: "FIDE 1518",
    record: "National Player",
    testId: "coach-card-1",
  },
];

const CoachCards = () => (
  <div className="mt-16" data-testid="coach-profiles">
    <div className="flex flex-col md:flex-row md:items-end justify-between mb-8">
      <h3 className="font-display text-2xl uppercase tracking-tight text-emerald-950">Meet the Coach</h3>
      <p className="text-xs font-mono text-stone-500 mt-2 md:mt-0 max-w-sm">
        On the tournament floor &mdash; FIDE-rated rapid &amp; blitz event.
      </p>
    </div>
    <div className="flex justify-center">
      {COACH_SLOTS.map((coach) => (
        <div
          key={coach.slot}
          data-testid={coach.testId}
          className="w-full max-w-sm bg-[#faf9f5] border border-stone-300 rounded-lg overflow-hidden flex flex-col shadow-sm"
        >
          <div className="aspect-[4/5] overflow-hidden">
            <img
              src={coach.photo}
              alt={`${coach.name}, ${coach.role}`}
              className="w-full h-full object-cover object-center"
              loading="lazy"
            />
          </div>
          <div className="p-5 flex-1 flex flex-col">
            <div className="font-mono text-[10px] uppercase tracking-widest text-emerald-800">{coach.role}</div>
            <div className="font-display text-xl uppercase text-stone-900 mt-1" data-testid={`${coach.testId}-name`}>
              {coach.name}
            </div>
            <div className="mt-3 space-y-1 text-xs font-mono text-stone-600">
              <div data-testid={`${coach.testId}-rating`}>Rating &middot; {coach.rating}</div>
              <div data-testid={`${coach.testId}-record`}>{coach.record}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const Mentors = () => {
  return (
    <section id="ratings" className="py-20 border-b border-stone-300 bg-white" data-testid="mentors-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="font-mono text-xs uppercase tracking-widest text-emerald-800 mb-2">Chapter 03</div>
            <h2 className="font-display text-3xl uppercase tracking-tight text-emerald-950">FIDE Rated Faculty</h2>
            <p className="text-stone-600 mt-4 leading-relaxed" data-testid="mentors-blurb">
              Our trainers are not casual hobbyists. Each holds official FIDE international ratings with
              competitive tournament credentials and a passion for teaching young minds.
            </p>
            <div className="mt-8">
              <a
                href="#contact"
                data-testid="mentors-trial-cta"
                className="inline-flex items-center text-xs font-mono uppercase tracking-widest text-emerald-950 font-bold hover:underline"
              >
                Meet the head coach at trial &rarr;
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative aspect-[16/9] rounded-lg overflow-hidden border border-stone-300 shadow-md" data-testid="mentors-image">
              <img
                src={COACH_IMAGE}
                alt="Chess coach guiding children through a game in the academy classroom"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/80 via-emerald-950/10 to-transparent" />
              <div className="absolute inset-0 p-6 flex flex-col justify-between">
                <div className="flex justify-between items-start">
                  <span className="font-mono text-xs uppercase text-emerald-200 bg-emerald-950/70 px-2 py-1 rounded">Active Competitors</span>
                  <span className="text-xs font-mono text-white bg-black/50 px-2 py-1 rounded">FIDE Verified</span>
                </div>
                <div className="bg-black/75 backdrop-blur-sm p-4 rounded border border-stone-800">
                  <p className="font-mono text-xs text-emerald-300">Head Coach</p>
                  <p className="font-display text-xl text-white uppercase mt-0.5">Gaurav Gautam &middot; FIDE 1518</p>
                  <p className="text-xs text-stone-300 mt-1">
                    National player specializing in pawn structures &amp; time management under tournament conditions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CoachCards />
      </div>
    </section>
  );
};
